module.exports = __webpack_public_path__ + "img/Dantam Fashion 16.551e3556.jpg";